import {
  getLatestPerf,
  getLatestPerfDetail
} from '@/pages-v2/home/workbench/service'

import {
  getIndicatorTabList,
  getShopList
} from '@/pages-v2/performance/service'
export default {
  // 获取商家列表
  async getLatestPerf ({ commit, state }, params = {}) {
    const performance = await getLatestPerf(params)
    commit('updatePerformance', performance)
  },

  updatePerformanceTabCurrent ({ commit, state }, params = {}) {
    const { current } = params
    commit('updatePerformanceTabCurrent', current)
  },

  // async getShopListFilter ({commit, state}, params = {}) {
  //   const filters = await getShopListFilter(params)
  //   commit('getShopListFilter', filters)
  // },

  async getIndicatorTabList ({ commit, state }, params = {}) {
    const tabs = await getIndicatorTabList(params)
    commit('updateIndicatorTabs', tabs)
  },

  async getShopList ({ commit, state }, params = {}) {
    const data = await getShopList(params)
    commit('updateShopList', data)
  },

  setFilterParams ({ commit, state }, params = {}) {
    commit('setFilterParams', params)
  },
  resetFilterParams ({ commit, state }, params = {}) {
    commit('resetFilterParams')
  },
  async getLatestPerfDetail ({ commit, state }, params) {
    try {
      const res = await getLatestPerfDetail(params)
      commit('updatePerfDetail', res)
      return res
    } catch (error) {
      console.error(error)
    }
  }
}
